export default __webpack_public_path__ + "static/media/VEB_docAndRx.3b5dc863.png";